
import React from 'react';
import "./index.less"
import closeDark from "images/close-dark.svg"

const AdminiIframeBanner = (props) => {

    const [isVisible, setIsVisible] = React.useState(true)

    const handleClose = () => {
        setIsVisible(false)
        props.onClose && props.onClose()
    }

    const url = `https://app.manduhr.com/transfer/${props.adminHash}`

    return (
        <>
            {isVisible && (
                <div className="admin-iframe-banner">
                    <p className="admin-iframe-banner-wrapper">
                        <span className="admin-iframe-banner-text">
                            <b>¡Recuerda!</b>
                            {" "}Para gestionar divisiones, colaboradores, encuestas y configuraciones generales, haz <a target='_blank'  style={{ textDecoration: "underline" }} href={url}>click aquí</a>.
                        </span>
                    </p>
                    <img onClick={handleClose} className='admin-iframe-banner-close-icon' src={closeDark} />
                </div>
            )}
        </>
    ) 
}

export default AdminiIframeBanner